import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M18.538 29.333H13.46c-5.216 0-9.46-4.389-9.46-9.784v-4.432c0-5.395 4.244-9.783 9.461-9.783h5.078c5.216 0 9.461 4.388 9.461 9.784v4.432c0 5.394-4.244 9.784-9.461 9.784l-.001-.001zM13.46 7.749c-3.928 0-7.124 3.305-7.124 7.368v4.432c0 4.062 3.196 7.367 7.124 7.367h5.078c3.928 0 7.124-3.305 7.124-7.367v-4.432c0-4.063-3.196-7.368-7.124-7.368H13.46z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m21.276 13.67-.12-.122a1.06 1.06 0 0 0-1.533.012l-4.265 4.48a.603.603 0 0 1-.87.01l-2.13-2.15a1.058 1.058 0 0 0-1.531.02l-.118.125a1.148 1.148 0 0 0 .019 1.584l3.46 3.493c.21.212.483.319.757.319.273 0 .56-.112.771-.334l5.571-5.852a1.13 1.13 0 0 0 .312-.794c-.003-.3-.117-.58-.323-.79z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "background",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.461 7.75c-3.928 0-7.124 3.304-7.124 7.367v4.432c0 4.062 3.196 7.367 7.124 7.367h5.078c3.928 0 7.124-3.305 7.124-7.367v-4.432c0-4.063-3.196-7.368-7.124-7.368H13.46zm7.694 5.798.121.123c.206.21.32.49.323.79a1.13 1.13 0 0 1-.312.794l-5.57 5.851a1.073 1.073 0 0 1-.772.334c-.274 0-.547-.106-.757-.318l-3.46-3.493a1.148 1.148 0 0 1-.02-1.584l.119-.125a1.056 1.056 0 0 1 1.532-.02l2.13 2.15c.241.244.631.24.869-.01l4.265-4.48a1.06 1.06 0 0 1 1.532-.012z",
  fill: "#006240",
  "fill-opacity": "0"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}